import { useCallback, useMemo, useState } from 'react';
import debounce from 'lodash.debounce';

// `initialValue` sirve para listados cuya búsqueda viene del querystring: el
// primer fetch tiene que salir ya con el término aplicado.
export const useDebouncedSearch = (
  wait: number = 500,
  initialValue: string = '',
) => {
  const [value, setValue] = useState(initialValue);
  const [query, setQueryDebounced] = useState(initialValue);

  const flushQuery = useMemo(() => debounce(setQueryDebounced, wait), [wait]);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const next = e.target.value;
      setValue(next);
      flushQuery(next);
    },
    [flushQuery],
  );

  const setQuery = useCallback((next: string) => {
    setValue(next);
    setQueryDebounced(next);
  }, []);

  return {
    value,
    query,
    setQuery,
    onChange,
  };
};
